<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestión de formularios</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn dark color="green" @click.stop="formularioModalOpen()">
                            NUEVO FORMULARIO
                        </v-btn>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            item-key="id"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.id }}</td>
                            <td class="text-xs-center">{{ props.item.nombre }}</td>
                            <td class="text-xs-right">{{ props.item.activo }}</td>
                            <td class="text-xs-right">{{ props.item.version }}</td>
                            <td class="text-xs-center">
                                <v-btn color="orange" flat icon :to="'/formulario/' + props.item.id + '/preguntas'">
                                    <v-icon>live_help</v-icon>
                                </v-btn>
                                <v-btn color="red" flat icon @click.native="">
                                    <v-icon>delete</v-icon>
                                </v-btn>

                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <!--// MODAL FORMULARIO//////////////////////////////////////////-->
        <v-dialog v-model="formularioModal">
            <v-card>
                <v-card-title><h3>Agregar formulario</h3></v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container grid-list-xs>
                        <v-layout>
                            <v-flex>
                                <v-text-field label="Nombre" v-model="f.nombre"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Version" v-model="f.version"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click.native="formularioModal = false">Cancelar</v-btn>
                    <v-btn color="green" flat @click.native="formularioAdd">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--// MODAL PREGUNTAS//////////////////////////////////////////-->
        <v-dialog v-model="preguntasModal" scrollable>
            <v-card>
                <v-card-title><h3>Agregar preguntas</h3></v-card-title>
                <v-divider></v-divider>
                <v-card-text ref="preguntasList">
                    <v-layout text-xs-center>
                        <v-flex>
                            <v-btn flat icon @click="scroll" color="orange">
                                <v-icon>arrow_downward</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-list three-line>
                        <draggable v-model="formulario.preguntas" @end="preguntasOrden()">
                            <transition-group name="list-complete">
                                <div class="list-complete-item" v-for="p in formulario.preguntas" :key="p.id">
                                    <v-list-tile>
                                        <v-list-tile-action>{{ p.id }}</v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Pregunta: {{ p.pregunta }}</v-list-tile-title>
                                            <v-list-tile-sub-title>Tipo: {{ tipo(p.pregunta_tipo_id) }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title v-if="p.opciones.length > 0">
                                                Opciones:
                                                <template v-for="o in p.opciones">
                                                    <v-chip small>{{ o }}</v-chip>
                                                </template>
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-btn color="red" flat icon>
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </div>
                            </transition-group>
                        </draggable>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-container grid-list-sm fluid>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field label="Pregunta" v-model="p.pregunta"></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-autocomplete label="Tipo de pregunta"
                                                            v-model="p.pregunta_tipo_id"
                                                            :items="tipos"
                                                            item-value="id"
                                                            item-text="desig">
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex v-if="p.pregunta_tipo_id === 5 || p.pregunta_tipo_id === 4">
                                            <v-combobox
                                                    v-model="p.opciones"
                                                    :items="opciones"
                                                    :search-input.sync="opcionesSearch"
                                                    hide-selected
                                                    label="Adicionar opciones"
                                                    multiple
                                                    persistent-hint
                                                    small-chips
                                            >
                                                <template slot="no-data">
                                                    <v-list-tile>
                                                        <v-list-tile-content>
                                                            <v-list-tile-title>
                                                                Presione <kbd>enter</kbd> para crear una nueva opción
                                                            </v-list-tile-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </template>
                                            </v-combobox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn flat icon color="green" @click.native="preguntaAdd()" :loading="preguntaLoading">
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click.native="preguntasModal = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import draggable from 'vuedraggable'
    import mixinFormulario from '../../mixins/formulario/formulario';
    import mixinPregunta from '../../mixins/formulario/pregunta';
    import {mapActions} from 'vuex';


    export default {
        name: "formulario",
        mixins: [mixinFormulario, mixinPregunta],
        components: {draggable},
        data() {
            return {
                preguntaLoading: false,
                preguntasModal: false,
                preguntasOper: 'add',
                formularioModal: false,
                loading: false,
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Nombre', value: 'nombre', align: 'center'},
                    {text: 'Version', value: 'version', align: 'center'},
                    {text: 'Activo', value: 'activo', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                search: '',
                pag: {},
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                totalItems: 0,
                f: {
                    nombre: '',
                    version: ''
                },
                p: {
                    pregunta: '',
                    pregunta_tipo_id: '',
                    opciones: []
                },
                formulario: {
                    preguntas: []
                },
                opcionesSearch: '',
                opciones: [],
                tipos: []
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getTableData();
                },
                deep: true
            }
        },
        mounted() {
            this.preguntaTipos(r => {
                this.tipos = r;
            }, err => {
                console.log('erro al cargar tipos de preguntas')
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            tipo(val) {
                let r = this.tipos.find(r => r.id === val);
                return r.desig;
            },
            getTableData() {
                this.loading = true;
                this.formularioIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            formularioModalOpen() {
                this.formularioModal = true;
            },
            formularioAdd() {
                this.formularioStore(this.f, r => {
                    this.getTableData();
                    this.msjShow(r);
                    this.formularioModal = false;
                }, err => {
                    console.error('Error al guardar formulario');
                    this.msjShow({txt: err, tipo: 'error'});
                })
            },
            preguntaModalOpen(formulario) {
                this.formularioShow(formulario, r => {
                    this.formulario = r;
                    this.preguntasModal = true;
                }, err => {
                    console.error('Error al traer formulario')
                })

            },
            preguntaAdd() {
                this.preguntaLoading = true;
                this.preguntaStore({
                    formulario_id: this.formulario.id,
                    pregunta: this.p
                }, r => {
                    this.formulario.preguntas.push(r.p);
                    this.p = {
                        pregunta: '',
                        pregunta_tipo_id: '',
                        opciones: [],
                    };
                    this.scroll();
                    this.msjShow(r);
                    this.preguntaLoading = false;
                }, err => {
                    this.msjShow({txt: err, tipo: 'error'});
                    this.preguntaLoading = false;
                })
            },
            preguntasOrden() {
                this.preguntaOrden(this.formulario.preguntas, r => {
                    this.msjShow(r);
                }, err => {
                    this.msjShow({txt: err, tipo: 'error'});
                })
            },
            scroll() {
                this.$nextTick(() => {
                    this.$refs.preguntasList.scrollTop = this.$refs.preguntasList.scrollHeight;
                })

            }
        }
    }
</script>

<style>
    .list-complete-item {
        transition: all 1s;
    }

    .list-complete-enter, .list-complete-leave-active {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/gestion.vue